<template>
  <div class="desk-frame contact-page">
    <div
      class="head_row_calander bg--white flex flex--content--center no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">צור קשר עם בית החולים</h1>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <div class="contact h-main bg--white m-no-bg page-edit-padd">
        <div class="before-send" v-show="!formSent">
          <div class="text center let-1 mb--22">
            שלום {{ activeDoctor.name }},
            <br />
            באפשרותך לשלוח פנייה ישירה למחלקות בבית החולים בטופס מטה.
          </div>
          <form @submit.prevent="sendForm" autocomplete="off">
            <div class="filter_select">
              <select2 name="subject" v-model="subject">
                <option value="">בחר מחלקה</option>
                <option
                  v-for="(subject, index) in subjects"
                  :key="index"
                  :value="subject"
                >
                  {{ subject }}
                </option>
              </select2>
            </div>
            <div class="form_input">
              <textarea
                placeholder="הקלד הודעה כאן..."
                v-model="text"
                autocomplete="off"
              ></textarea>
            </div>
            <div class="form_submit" :class="{ bt_disable: emptyForm }">
              <input type="submit" value="שליחה" />
            </div>
          </form>
          <div class="error-message" v-if="errorMessge">{{ errorMessge }}</div>
        </div>

        <div class="after-send m-center" v-show="formSent">
          <Thank />
          <div class="title tx--blue2">
            תודה, פנייתך נשלחה<br />
            בהצלחה!
          </div>
          <!-- <div class="text let-1">
            פסקת טקסט קצרה כאן משהו לומר בקצרה ליצירת קשר
          </div> -->
          <button class="bt_blue w-100" @click="formSent = false">
            שליחת פניה נוספת
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Thank from "@/assets/img/svg/thank.svg";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import { mapGetters, mapMutations, mapState } from "vuex";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import Error from "@/components/Popups/Error";

export default {
  name: "Contact",

  components: {
    Thank,
    Menu,
    DashboardHeader,
    MenuDesktop
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"]),
    ...mapState(["activeUser", "activeDoctor"]),
    emptyForm() {
      if (this.text) {
        return false;
      }
      return true;
    }
  },
  data: function() {
    return {
      loaded: false,
      formSent: false,
      subjects: [],
      text: "",
      subject: "",
      errorMessge: ""
    };
  },
  methods: {
    ...mapMutations(["UPDATE_MENU_STATE"]),
    sendForm() {
      this.errorMessge = "";
      this.$API
        .sendForm(
          this.activeDoctor.name,
          this.activeUser.user_id,
          this.subject,
          this.text
        )
        .then(res => {
          if (res.status == "ERROR") {
            this.errorMessge = res.message;
          } else {
            this.formSent = true;
          }
        })
        .catch(e => {
          if (e.status == "ERROR") {
            this.errorMessge = e.message;
          }
        });
    }
  },
  mounted() {
    this.loaded = true;
    this.$API
      .getTypehead("form_subjects")
      .then(res => {
        this.subjects = res;
      })
      .catch(e => {
        this.$modal.show(Error);
      });
    if (this.MENU_ACTIVE) {
      this.UPDATE_MENU_STATE(false);
    }
  },
  created() {}
};
</script>
